module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"afterTax":"{0} after tax relief","pm":"per month"}}')
  delete Component.options._Ctor
}
